import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';
import resourceSubject from 'next/javascripts/reactivity/resource-subject';

Component('tr-project-timeline', {
  mixins: [eventListenerMixin],

  properties: {
    url: String,

    fullsize: {
      type: Boolean,
      default: true,
    },

    sidebarWidth: {
      type: Number,
      default: 240,
      observer: 'renderSidebarWidth',
    },
  },

  connected() {
    const headerNav = document.querySelector('#nav-project');
    if (headerNav) headerNav.classList.add('active');

    window.scrollTo(0, 0);
    document.body.classList.add('body-timeline');
    if (this.fullsize) document.body.classList.add('body-fullscreen');

    this.ignoreScroll = false;
    this.sidebar = this.querySelector('tr-project-timeline-sidebar');
    this.sidebarContainer = this.querySelector('.sidebar-container');
    this.timelineContainer = this.querySelector('.timeline-container');

    this.listenTo(this.sidebarContainer, 'scroll', this.handleSidebarScroll.bind(this));
    this.listenTo(this.timelineContainer, 'scroll', this.handleTimelineScroll.bind(this));
    this.listenTo(this.sidebar, {
      'tr-project-timeline-sidebar:resize': (event) => {
        this.classList.add('resizing');
        this.sidebarWidth = event.detail;
      },
      'tr-project-timeline-sidebar:stopResize': (event) => {
        this.classList.remove('resizing');
        localStorage.setItem('timeline-sidebar-width', event.detail);
      },
    });

    this.renderHeight();
  },

  ready() {
    const width = localStorage.getItem('timeline-sidebar-width');
    if (width) this.sidebarWidth = width * 1;
    this.sidebar.initGroupToggle();
    this.renderToday();
    this.initDragScroll();
    this.initSubscription();
  },

  initSubscription() {
    this.subscription = resourceSubject('todo').subscribe({
      next: () => {
        $.ajax({
          url: this.url,
          method: 'get',
          dataType: 'script',
        });
      },
    });
  },

  renderHeight() {
    const header = document.querySelector('.header');
    const projectHeader = document.querySelector('tr-project-header');

    let height = 0;
    if (header) height += header.offsetHeight;
    if (projectHeader) height += header.projectHeader;
    this.style.height = `calc(100vh - ${height}px)`;
  },

  handleSidebarScroll() {
    if (this.handleIgnoreScroll()) return;
    this.timelineContainer.scrollTop = this.sidebarContainer.scrollTop;
  },

  handleTimelineScroll() {
    if (this.handleIgnoreScroll()) return;
    this.sidebarContainer.scrollTop = this.timelineContainer.scrollTop;
  },

  // 保证不糊重复触发 scroll 事件
  handleIgnoreScroll() {
    this.ignoreScroll = !this.ignoreScroll;
    return !this.ignoreScroll;
  },

  initDragScroll() {
    this.listenTo(this.timelineContainer, {
      mouseup: () => {
        this.scrolling = false;
      },
      mouseleave: () => {
        this.scrolling = false;
      },
      mousedown: (e) => {
        if (
          closest(e.target, '.timeline-todo-wrapper')
          || closest(e.target, '.timeline-group-wrapper')
        ) return;
        this.scrolling = true;
        this.startX = e.pageX;
      },
      mousemove: (e) => {
        if (!this.scrolling) return;
        e.preventDefault();
        const scrollLeft = this.timelineContainer.scrollLeft - (e.pageX - this.startX);
        this.timelineContainer.scrollLeft = scrollLeft;
        this.startX = e.pageX;
      },
    });
  },

  renderToday() {
    const today = window.moment().format('YYYY-MM-DD');

    const day = this.querySelector(`.timeline-header-day[data-date="${today}"]`);
    if (day) day.classList.add('today');
    const column = this.querySelector(`.timeline-layout-column[data-date="${today}"]`);
    if (column) {
      column.classList.add('today');
      this.timelineContainer.scrollLeft = column.offsetLeft - 7 * 48;
    }
  },

  renderSidebarWidth() {
    if (this.animationFrame) window.cancelAnimationFrame(this.animationFrame);
    this.animationFrame = window.requestAnimationFrame(() => {
      this.style.paddingLeft = `${this.sidebarWidth}px`;
      this.sidebar.style.width = `${this.sidebarWidth}px`;
    });
  },

  disconnected() {
    this.stopListening();
    this.subscription.unsubscribe();
    document.body.classList.remove('body-timeline');
  },
});
